import LinkToDocusaurus from '../LinkToDocusaurus'
import { snippetEditor } from '../../docs-routes'

const LinkToSnippetsDoc = () =>
  <LinkToDocusaurus path={snippetEditor}>
    Learn more about Snippets
  </LinkToDocusaurus>

export default LinkToSnippetsDoc
